export enum LocaleEnum {
	FR_FR = 'FR_FR',
	FR_BE = 'FR_BE',
	NL_BE = 'NL_BE',
	EN_GB = 'EN_GB',
	EN_BE = 'EN_BE',
	EN_FR = 'EN_FR',
	DE_LU = 'DE_LU',
	DE_DE = 'DE_DE',
	NL_NL = 'NL_NL',
	ES_ES = 'ES_ES',
	IT_IT = 'IT_IT',
}
